/* eslint-disable no-param-reassign */
export default {
    install: function install(app, i18n, store) {
        app.$i18n = i18n;
        app.$store = store;
        // i18n exposes an install function via createI18n
        i18n.install(app);
    },
};
